import XLSX from 'xlsx-js-style';
import { toast } from '../../common_components/Toast/ToastUtils';
const titleStyle = {
    font: { bold: true, sz: 14, color: { rgb: '181D27' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const subTitleStyle = {
    font: { italic: true, sz: 10, color: { rgb: '667085' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const headerStyle = {
    font: { bold: true, sz: 11, color: { rgb: '181D27' } },
    fill: { fgColor: { rgb: 'E5E7EB' } },
    alignment: { horizontal: 'left', vertical: 'center' },
    border: {
        top: { style: 'thin', color: { rgb: 'D0D5DD' } },
        bottom: { style: 'thin', color: { rgb: 'D0D5DD' } },
        left: { style: 'thin', color: { rgb: 'D0D5DD' } },
        right: { style: 'thin', color: { rgb: 'D0D5DD' } },
    },
};
const dataCellStyle = {
    font: { sz: 10, color: { rgb: '27272A' } },
    alignment: { horizontal: 'left', vertical: 'center' },
    border: {
        top: { style: 'thin', color: { rgb: 'E5E7EB' } },
        bottom: { style: 'thin', color: { rgb: 'E5E7EB' } },
        left: { style: 'thin', color: { rgb: 'E5E7EB' } },
        right: { style: 'thin', color: { rgb: 'E5E7EB' } },
    },
};
const summaryRowStyle = {
    font: { bold: true, sz: 11, color: { rgb: '181D27' } },
    fill: { fgColor: { rgb: 'F3F4F6' } },
    alignment: { horizontal: 'left', vertical: 'center' },
    border: {
        top: { style: 'thin', color: { rgb: 'D0D5DD' } },
        bottom: { style: 'thin', color: { rgb: 'D0D5DD' } },
        left: { style: 'thin', color: { rgb: 'D0D5DD' } },
        right: { style: 'thin', color: { rgb: 'D0D5DD' } },
    },
};
const pct = (value) => value !== undefined && value !== null ? `${value.toFixed(1)}%` : '0.0%';
const diffPct = (value) => {
    if (value === undefined || value === null)
        return '0%';
    const sign = value > 0 ? '+' : '';
    return `${sign}${value.toFixed(1)}%`;
};
const formatNumber = (value) => {
    if (value === undefined || value === null || value === '')
        return '0';
    const num = Number(value);
    if (isNaN(num))
        return String(value);
    return num.toLocaleString('en-US');
};
export function exportOutreachPerformance({ entities, teamTotal, groupBy, startDate, endDate, compareStartDate, compareEndDate, }) {
    if (!entities || !Array.isArray(entities) || entities.length === 0) {
        toast.info('No data available to export');
        return;
    }
    try {
        const isSpecialist = groupBy === 'specialist';
        const isComparing = Boolean(compareStartDate && compareEndDate);
        let headers = [];
        if (isComparing) {
            headers = isSpecialist
                ? [
                    'Outreach Specialist',
                    'Clients Count',
                    '# of Trackers',
                    '# of Trackers (Prev)',
                    'Trackers Diff',
                    'Contacts In Trackers',
                    '# of Enrollments',
                    '# of Enrollments (Prev)',
                    'Enrollments Diff',
                    'Reach %',
                    'Leads Actual',
                    'Leads (Prev)',
                    'Leads Diff',
                    'Placements Goal',
                    'Placements Placed',
                    'Placements (Prev)',
                    'Placements Diff',
                    'Placements VAR',
                    'Out→Lead Conversion',
                    'Out→Lead (Prev)',
                    'Out→Lead Diff',
                    'Lead → Placement Conv. Rate',
                    'Lead → Placement (Prev)',
                    'Lead → Placement Diff',
                ]
                : [
                    'Client',
                    '# of Trackers',
                    '# of Trackers (Prev)',
                    'Trackers Diff',
                    'Contacts In Trackers',
                    '# of Enrollments',
                    '# of Enrollments (Prev)',
                    'Enrollments Diff',
                    'Reach %',
                    'Leads Actual',
                    'Leads (Prev)',
                    'Leads Diff',
                    'Placements Goal',
                    'Placements Placed',
                    'Placements (Prev)',
                    'Placements Diff',
                    'Placements VAR',
                    'Out→Lead Conversion',
                    'Out→Lead (Prev)',
                    'Out→Lead Diff',
                    'Lead → Placement Conv. Rate',
                    'Lead → Placement (Prev)',
                    'Lead → Placement Diff',
                ];
        }
        else {
            headers = isSpecialist
                ? [
                    'Outreach Specialist',
                    'Clients Count',
                    '# of Trackers',
                    'Contacts In Trackers',
                    '# of Enrollments',
                    'Reach %',
                    'Leads Actual',
                    'Placements Goal',
                    'Placements Placed',
                    'Placements VAR',
                    'Out→Lead Conversion',
                    'Lead → Placement Conv. Rate',
                ]
                : [
                    'Client',
                    '# of Trackers',
                    'Contacts In Trackers',
                    '# of Enrollments',
                    'Reach %',
                    'Leads Actual',
                    'Placements Goal',
                    'Placements Placed',
                    'Placements VAR',
                    'Out→Lead Conversion',
                    'Lead → Placement Conv. Rate',
                ];
        }
        const dataRows = entities.map((row) => {
            const placedVal = row.placements_count?.actual_placement ?? row.placements?.length ?? 0;
            const prevPlacedVal = row.placements_count?.prev_placement ?? 0;
            const placedDiff = row.placements_count?.placement_diff;
            const placedGoal = row.placements_count?.goal_placement ?? 0;
            const placedVar = row.placements_count?.per_goal;
            const trackers = row.trackers?.actual_trackers ?? 0;
            const prevTrackers = row.trackers?.prev_trackers ?? 0;
            const trackersDiff = row.trackers?.trackers_diff;
            const totalContacts = row.outreach?.total_contacts ?? 0;
            const enrollmentsReach = row.outreach?.reach_pct;
            if (isComparing) {
                if (isSpecialist) {
                    return [
                        row.name || '',
                        formatNumber(row.assigned_client_count ?? row.assigned_clients?.length ?? row.clients?.length ?? 0),
                        formatNumber(trackers),
                        formatNumber(prevTrackers),
                        diffPct(trackersDiff),
                        formatNumber(totalContacts),
                        formatNumber(row.outreach?.actual_outreach ?? 0),
                        formatNumber(row.outreach?.prev_outreach ?? 0),
                        diffPct(row.outreach?.outreach_diff),
                        pct(enrollmentsReach),
                        formatNumber(row.leads?.actual_lead ?? 0),
                        formatNumber(row.leads?.prev_lead ?? 0),
                        diffPct(row.leads?.lead_diff),
                        formatNumber(placedGoal),
                        formatNumber(placedVal),
                        formatNumber(prevPlacedVal),
                        diffPct(placedDiff),
                        pct(placedVar),
                        pct(row.conversion?.out_lead),
                        pct(row.conversion?.prev_out_lead),
                        diffPct(row.conversion?.out_lead_diff),
                        pct(row.conversion?.lead_place),
                        pct(row.conversion?.prev_lead_place),
                        diffPct(row.conversion?.lead_place_diff),
                    ];
                }
                else {
                    return [
                        row.name || '',
                        formatNumber(trackers),
                        formatNumber(prevTrackers),
                        diffPct(trackersDiff),
                        formatNumber(totalContacts),
                        formatNumber(row.outreach?.actual_outreach ?? 0),
                        formatNumber(row.outreach?.prev_outreach ?? 0),
                        diffPct(row.outreach?.outreach_diff),
                        pct(enrollmentsReach),
                        formatNumber(row.leads?.actual_lead ?? 0),
                        formatNumber(row.leads?.prev_lead ?? 0),
                        diffPct(row.leads?.lead_diff),
                        formatNumber(placedGoal),
                        formatNumber(placedVal),
                        formatNumber(prevPlacedVal),
                        diffPct(placedDiff),
                        pct(placedVar),
                        pct(row.conversion?.out_lead),
                        pct(row.conversion?.prev_out_lead),
                        diffPct(row.conversion?.out_lead_diff),
                        pct(row.conversion?.lead_place),
                        pct(row.conversion?.prev_lead_place),
                        diffPct(row.conversion?.lead_place_diff),
                    ];
                }
            }
            else {
                if (isSpecialist) {
                    return [
                        row.name || '',
                        formatNumber(row.assigned_client_count ?? row.assigned_clients?.length ?? row.clients?.length ?? 0),
                        formatNumber(trackers),
                        formatNumber(totalContacts),
                        formatNumber(row.outreach?.actual_outreach ?? 0),
                        pct(enrollmentsReach),
                        formatNumber(row.leads?.actual_lead ?? 0),
                        formatNumber(placedGoal),
                        formatNumber(placedVal),
                        pct(placedVar),
                        pct(row.conversion?.out_lead),
                        pct(row.conversion?.lead_place),
                    ];
                }
                else {
                    return [
                        row.name || '',
                        formatNumber(trackers),
                        formatNumber(totalContacts),
                        formatNumber(row.outreach?.actual_outreach ?? 0),
                        pct(enrollmentsReach),
                        formatNumber(row.leads?.actual_lead ?? 0),
                        formatNumber(placedGoal),
                        formatNumber(placedVal),
                        pct(placedVar),
                        pct(row.conversion?.out_lead),
                        pct(row.conversion?.lead_place),
                    ];
                }
            }
        });
        const totalPlacedVal = teamTotal?.placements?.actual_placement ?? teamTotal?.placements?.total ?? 0;
        const totalPrevPlacedVal = teamTotal?.placements?.prev_placement ?? 0;
        const totalPlacedDiff = teamTotal?.placements?.placement_diff;
        const totalPlacedGoal = teamTotal?.placements?.goal_placement ?? 0;
        const totalPlacedVar = teamTotal?.placements?.per_goal;
        const totalTrackers = teamTotal?.trackers?.actual_trackers ?? 0;
        const totalPrevTrackers = teamTotal?.trackers?.prev_trackers ?? 0;
        const totalTrackersDiff = teamTotal?.trackers?.trackers_diff;
        const totalContactsInTrackers = teamTotal?.outreach?.total_contacts ?? 0;
        const totalEnrollmentsReach = teamTotal?.outreach?.reach_pct;
        let summaryRow = [];
        if (isComparing) {
            summaryRow = isSpecialist
                ? [
                    'Total Summary',
                    `${formatNumber(teamTotal?.client_count ?? 0)} clients`,
                    formatNumber(totalTrackers),
                    formatNumber(totalPrevTrackers),
                    diffPct(totalTrackersDiff),
                    formatNumber(totalContactsInTrackers),
                    formatNumber(teamTotal?.outreach?.actual_outreach ?? 0),
                    formatNumber(teamTotal?.outreach?.prev_outreach ?? 0),
                    diffPct(teamTotal?.outreach?.outreach_diff),
                    pct(totalEnrollmentsReach),
                    formatNumber(teamTotal?.leads?.actual_lead ?? 0),
                    formatNumber(teamTotal?.leads?.prev_lead ?? 0),
                    diffPct(teamTotal?.leads?.lead_diff),
                    formatNumber(totalPlacedGoal),
                    formatNumber(totalPlacedVal),
                    formatNumber(totalPrevPlacedVal),
                    diffPct(totalPlacedDiff),
                    pct(totalPlacedVar),
                    pct(teamTotal?.conversion?.out_lead),
                    pct(teamTotal?.conversion?.prev_out_lead),
                    diffPct(teamTotal?.conversion?.out_lead_diff),
                    pct(teamTotal?.conversion?.lead_place),
                    pct(teamTotal?.conversion?.prev_lead_place),
                    diffPct(teamTotal?.conversion?.lead_place_diff),
                ]
                : [
                    'Total Summary',
                    formatNumber(totalTrackers),
                    formatNumber(totalPrevTrackers),
                    diffPct(totalTrackersDiff),
                    formatNumber(totalContactsInTrackers),
                    formatNumber(teamTotal?.outreach?.actual_outreach ?? 0),
                    formatNumber(teamTotal?.outreach?.prev_outreach ?? 0),
                    diffPct(teamTotal?.outreach?.outreach_diff),
                    pct(totalEnrollmentsReach),
                    formatNumber(teamTotal?.leads?.actual_lead ?? 0),
                    formatNumber(teamTotal?.leads?.prev_lead ?? 0),
                    diffPct(teamTotal?.leads?.lead_diff),
                    formatNumber(totalPlacedGoal),
                    formatNumber(totalPlacedVal),
                    formatNumber(totalPrevPlacedVal),
                    diffPct(totalPlacedDiff),
                    pct(totalPlacedVar),
                    pct(teamTotal?.conversion?.out_lead),
                    pct(teamTotal?.conversion?.prev_out_lead),
                    diffPct(teamTotal?.conversion?.out_lead_diff),
                    pct(teamTotal?.conversion?.lead_place),
                    pct(teamTotal?.conversion?.prev_lead_place),
                    diffPct(teamTotal?.conversion?.lead_place_diff),
                ];
        }
        else {
            summaryRow = isSpecialist
                ? [
                    'Total Summary',
                    `${formatNumber(teamTotal?.client_count ?? 0)} clients`,
                    formatNumber(totalTrackers),
                    formatNumber(totalContactsInTrackers),
                    formatNumber(teamTotal?.outreach?.actual_outreach ?? 0),
                    pct(totalEnrollmentsReach),
                    formatNumber(teamTotal?.leads?.actual_lead ?? 0),
                    formatNumber(totalPlacedGoal),
                    formatNumber(totalPlacedVal),
                    pct(totalPlacedVar),
                    pct(teamTotal?.conversion?.out_lead),
                    pct(teamTotal?.conversion?.lead_place),
                ]
                : [
                    'Total Summary',
                    formatNumber(totalTrackers),
                    formatNumber(totalContactsInTrackers),
                    formatNumber(teamTotal?.outreach?.actual_outreach ?? 0),
                    pct(totalEnrollmentsReach),
                    formatNumber(teamTotal?.leads?.actual_lead ?? 0),
                    formatNumber(totalPlacedGoal),
                    formatNumber(totalPlacedVal),
                    pct(totalPlacedVar),
                    pct(teamTotal?.conversion?.out_lead),
                    pct(teamTotal?.conversion?.lead_place),
                ];
        }
        const numCols = headers.length;
        const titleText = `Outreach Performance (${isSpecialist ? 'By Outreach Specialist' : 'By Client'})`;
        const subTitleText = `Date Range: ${startDate} to ${endDate}${compareStartDate && compareEndDate ? ` | Compared Period: ${compareStartDate} to ${compareEndDate}` : ''}`;
        const titleRow = [titleText, ...Array(numCols - 1).fill('')];
        const subTitleRow = [subTitleText, ...Array(numCols - 1).fill('')];
        const spacerRow = Array(numCols).fill('');
        const sheetData = [titleRow, subTitleRow, spacerRow, headers, ...dataRows, summaryRow];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        if (worksheet['A1'])
            worksheet['A1'].s = titleStyle;
        if (worksheet['A2'])
            worksheet['A2'].s = subTitleStyle;
        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: numCols - 1 } },
        ];
        // Header style row (index 3) - Left aligned
        for (let c = 0; c < numCols; c++) {
            const headerCell = XLSX.utils.encode_cell({ r: 3, c });
            if (worksheet[headerCell])
                worksheet[headerCell].s = headerStyle;
        }
        // Data rows style (index 4 to 4 + dataRows.length - 1) - Left aligned
        for (let r = 4; r < 4 + dataRows.length; r++) {
            for (let c = 0; c < numCols; c++) {
                const cellRef = XLSX.utils.encode_cell({ r, c });
                if (worksheet[cellRef]) {
                    worksheet[cellRef].s = dataCellStyle;
                }
            }
        }
        // Summary style row (index 4 + dataRows.length) - Left aligned
        const summaryRowIndex = 4 + dataRows.length;
        for (let c = 0; c < numCols; c++) {
            const cellRef = XLSX.utils.encode_cell({ r: summaryRowIndex, c });
            if (worksheet[cellRef])
                worksheet[cellRef].s = summaryRowStyle;
        }
        // Column widths
        worksheet['!cols'] = headers.map((h, index) => {
            if (index === 0)
                return { wch: 28 };
            return { wch: Math.max(h.length + 4, 14) };
        });
        const workbook = XLSX.utils.book_new();
        const sheetName = isSpecialist ? 'Specialist Performance' : 'Client Performance';
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        const fileName = `Outreach_Performance_${isSpecialist ? 'Specialist' : 'Client'}_${startDate}_to_${endDate}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    }
    catch (error) {
        console.error('Failed to export outreach performance:', error);
        toast.info('Failed to export. Please try again.');
    }
}
export default exportOutreachPerformance;
